//@ts-nocheck
//@ts-nocheck
import { useEffect, useRef, useState } from "react";

// type GoogleAutocompleteInputProps = {
//   vicinity?: boolean;
//   countryCode?: string;
//   placeDataResult: (result: any) => any;
//   value?: string;
//   children?: any;
// };
// add google autocomplete to window type
declare global {
  interface Window {
    google: any;
  }
}

export const useGoogleAutocomplete = ({
  vicinity,
  countryCode = "ng",
  defaultValue,
  onClick,
}: {
  vicinity?: boolean;
  countryCode?: string;
  defaultValue?: string;
  onClick?: (result: any[]) => any;
}) => {
  const inputNode = useRef(null);
  const autocomplete = useRef(null);
  const [results, placeDataResult] = useState([]);
  const [googleLoaded, setGoogleLoaded] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const fillInAddress = () => {
    // Get the place details from the autocomplete object.
    const place = autocomplete.current?.getPlace();
    placeDataResult(place);
    if (onClick) {
      onClick(place);
    }
  };
  function initAutocomplete(country: string, reset = false) {
    let types = vicinity ? ["regions"] : [];
    var options = {
      //types: ['address'],
      types,
      componentRestrictions: {
        country,
      },
    };
    console.log(options);
    if (
      inputNode.current &&
      googleLoaded &&
      window?.google?.maps?.places
      // && !autocomplete.current
    ) {
      var _autocomplete = new window.google.maps.places.Autocomplete(
        inputNode.current,
        options
      );
      _autocomplete.addListener("place_changed", fillInAddress);
      autocomplete.current = _autocomplete;
      setInitialized(true);
    }
  }
  useEffect(() => {
    const interval = setInterval(() => {
      if (window.google) {
        setGoogleLoaded(true);
        clearInterval(interval);
      }
      console.log("checking google");
    }, 1000);
    return () => clearInterval(interval);
  }, [googleLoaded]);
  useEffect(() => {
    if (googleLoaded && !initialized) {
      if (inputNode.current) {
        initAutocomplete(countryCode);
        inputNode.current.value = defaultValue || "";
        console.log("changed", defaultValue);
      }
    }
  }, [defaultValue, countryCode, googleLoaded, initialized]);
  return {
    inputNode,
    results,
    placeDataResult,
  };
};

// export const GoogleAutocompleteInput: React.FC<
//   GoogleAutocompleteInputProps
// > = ({
//   children,
//   vicinity = false,
//   countryCode = "ng",
//   placeDataResult,
//   value,
// }) => {
//   const inputNode = useRef(null);
//   const autocomplete = useRef(null);

//   const fillInAddress = () => {
//     // Get the place details from the autocomplete object.
//     const place = autocomplete.current?.getPlace();
//     placeDataResult(place);
//   };
//   function initAutocomplete() {
//     let types = vicinity ? ["regions"] : [];
//     var options = {
//       //types: ['address'],
//       types,
//       componentRestrictions: {
//         country: countryCode,
//       },
//     };
//     console.log(options);
//     if (inputNode.current && !autocomplete.current) {
//       var _autocomplete = new window.google.maps.places.Autocomplete(
//         inputNode.current,
//         options
//       );
//       _autocomplete.addListener("place_changed", fillInAddress);
//       autocomplete.current = _autocomplete;
//     }
//   }
//   useEffect(() => {
//     if (inputNode.current) {
//       inputNode.current.value = value;
//       initAutocomplete();
//     }
//   }, [value]);

//   if (children.length > 1) {
//     children = children[0];
//   }
//   const input = React.cloneElement(children, {
//     ref: inputNode,
//   });
//   return input;
// };
